// application/useCases/listarCajasSesion.usecase.js
import {
  listarSesionesCaja,
} from "../infraestructure/supabase/cajaSesion.repository.js";

import { mapCajaSesionFromDB }  from "../domain/mappers/cajaSesion.mapper.js";

export async function listarCajasSesionUseCase({
  punto,
  estado,
  desde,
  hasta,
} = {}) {
  // 🔹 Validaciones simples de input (no negocio)
  if (desde && hasta && desde > hasta) {
    throw new Error(
      "[ListarCajasSesionUseCase] El rango de fechas es inválido",
    );
  }

  // 1️⃣ Consultar BD
  const rows = await listarSesionesCaja({
    punto,
    estado,
    desde,
    hasta,
  });

  // 2️⃣ Mapear a dominio
  const sesiones = rows.map(mapCajaSesionFromDB);

  // 3️⃣ Devolver colección de dominio
  return sesiones;
}